// import { baseUrl, headers, jwtHeaders, logoutUtil } from "../common/data";
import { baseUrl, jwtHeaders} from "../common/data";

export const fetchAllAppointments = async () => {
    const response = await fetch(`${baseUrl}/api/appointment/getallappointments`, {
        method: "GET",
        // headers: headers,
        headers: jwtHeaders(),
        redirect: "follow",
    });
    const resData = await response?.json();
    // console.log('all appointments data=================================================>', resData);
    return resData;
};

export const createAppointment = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/appointment/create`, {
            method: 'POST',
            body: data,
            // headers: headers
            headers: jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('appointment add data=================================================>', resData);
        return resData;
    } catch (err) { }
};

export const deleteAppointment = async (data) => {
    try {
        const response = await fetch(`${baseUrl}/api/membership/deletemembership/${data}`, {
            method: 'DELETE',
            // headers: headers,
            headers: jwtHeaders(),
        })
        const resData = await response?.json();
        // console.log('info delete data=================================================>', resData);
        return resData;
    } catch (err) { }
};


// export const editInfo = async (data, id) => {
//     try {
//         const response = await fetch(`${baseUrl}/api/content/update/${id}`, {
//             method: 'PUT',
//             body: JSON.stringify(data),
//             headers: jwtHeaders()
//         })
//         const resData = await response?.json();
//         console.log('content edit data=================================================>', resData);
//         return resData;
//     } catch (err) { }
// };

export const fetchAppointmentsByStaff = async (id) => {
    const response = await fetch(`${baseUrl}/api/appointment/getstaffwise/${id}`, {
        method: "GET",
        // headers: headers,
        headers: jwtHeaders(),
        redirect: "follow",
    });
    const resData = await response?.json();
    // console.log('appointments data by staff=================================================>', resData);
    return resData;
};

export const fetchStaffAppointmentsDateWise=async(queryParams)=>{
    const response=await fetch(`${baseUrl}/api/appointment/staffAppointmentsDatewise${queryParams?queryParams:''}`,{
        method:'GET',
        // headers
        headers: jwtHeaders(),
    })
    const resData = await response?.json();
    // console.log('appointments data by staff=================================================>', resData);
    return resData;
}